// @ts-check
/**
 * Resolved contract variables. Does not mutate the document it is given.
 */
import { applyTheme } from "./applyTheme.js";
import { resolveTheme } from "./resolveTheme.js";

/**
 * @param {import("./resolveTheme.js").ThemeDocument | null} doc
 * @param {import("./resolveTheme.js").ThemeContract} contract
 */
export function themeVariables(doc, contract) {
  const { vars, problems } = resolveTheme(doc, contract);
  return { vars, problemCount: problems.length };
}

/**
 * Always writes variables, including when resolution throws.
 *
 * @param {Parameters<typeof applyTheme>[0]} target
 * @param {import("./resolveTheme.js").ThemeDocument | null} doc
 * @param {import("./resolveTheme.js").ThemeContract} contract
 * @param {string} themeId
 */
export function commitPresentation(target, doc, contract, themeId) {
  /** @type {Record<string, string>} */
  let vars = {};
  let problemCount = 0;
  try {
    const result = themeVariables(doc, contract);
    vars = result.vars;
    problemCount = result.problemCount;
  } catch {
    try {
      vars = themeVariables(null, contract).vars;
    } catch {
      vars = {};
    }
  }
  if (problemCount > 0) console.warn(`theme ${themeId}: ${problemCount} problem${problemCount === 1 ? "" : "s"}`);
  applyTheme(target, vars, themeId);
}
